import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getApiData } from "../../services/index";
import { Link } from "react-router-dom";
import styles from "./BlogDetails.module.css";
import Facebook from "../../assets/facebook.png";
import Instagram from "../../assets/instagram.png";
import LinkedIn from "../../assets/linkedin.png";
import WhatsApp from "../../assets/whatsapp.png"; // Import WhatsApp icon
import { Helmet } from "react-helmet";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    const fetchBlogDetails = async () => {
      const response = await getApiData("api/get_blog_Details", { slug });
      if (response.status === 200 && response.data.length > 0) {
        setBlog(response.data[0]);
      }
    };

    fetchBlogDetails();

    const fetchRecentBlogs = async () => {
      try {
        const result = await getApiData("api/get_recent_blogs_by_id", {
          params: {
            exclude_slug: slug,
          },
        });

        if (result && result.status === 200 && result.data.length > 0) {
          const filteredBlogs = result.data.filter((blog) => blog.slug !== slug);
          setBlogs(filteredBlogs);
        } else {
          setBlogs([]);
        }
      } catch (error) {
        console.error("Error fetching recent blogs:", error);
        setBlogs([]);
      }
    };

    if (slug) {
      fetchRecentBlogs();
    }
    console.log(blog, tags)
  }, [slug]);

  useEffect(() => {
    const checkData = async () => {
      const result = await getApiData("api/get_tags_list", {});
      if (result && result.status === 200) {
        setTags(result.data);
      }
    };

    checkData();
    console.log(blog, tags)
  }, []);

  // Social Share Functions
  const shareOnFacebook = (name) => {
    const url = window.location.href;
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?t=${encodeURIComponent(
      name
    )}&u=${encodeURIComponent(url)}`;
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  const shareOnLinkedIn = () => {
    const url = window.location.href;
    const title = blog ? blog.name : "Blog Post";
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url
    )}&title=${encodeURIComponent(title)}`;
    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  const copyToClipboardFallback = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      alert("Blog URL copied to clipboard. You can now share it on Instagram.");
    } catch (err) {
      alert("Failed to copy URL to clipboard. Please try again.");
    }
    document.body.removeChild(textarea);
  };

  const shareOnInstagram = () => {
    const url = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(() =>
          alert("Blog URL copied to clipboard. You can now share it on Instagram.")
        )
        .catch(() => copyToClipboardFallback(url));
    } else {
      copyToClipboardFallback(url);
    }
  };

  const shareOnWhatsApp = () => {
    const url = window.location.href;
    const message = blog
      ? `Check out this blog: ${blog.name} - ${url}`
      : `Check out this blog: ${url}`;
    const shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      message
    )}`;
    window.open(shareUrl, "_blank");
  };

  if (!blog) {
    return <p>Loading blog details...</p>;
  }

  return (
    <>
      <Helmet>
        <title>{blog.name}</title>
        <meta name="title" content={blog.meta_title} />
        <meta name="description" content={blog.meta_description} />
        <meta name="keywords" content={blog.meta_keyword} />
        <meta property="og:title" content={blog.name} />
        <meta property="og:description" content={blog.description} />
        <meta
          property="og:url"
          content={`http://localhost:3000/BlogDetails/${blog.slug}`}
        />
        <meta
          property="og:image"
          content={`${blog.image}`}
        />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="bcca-breadcrumb">
        <div className="bcca-breadcrumb-item">
          {blog.name} <i className="fa fa-pencil"></i>
        </div>
        <div className="bcca-breadcrumb-item">BlogDetails</div>
        <div className="bcca-breadcrumb-item">
          <Link to="/">Home</Link>
        </div>
      </div>
      <div className="section for-contact">
        <div className="container">
          <div
            className={`w-layout-grid contact-grid-main ${styles["contact-grid-main"]}`}>
            <div id="w-node-_28f8e666-bebf-7af6-ed46-f0415ce3f37d-4b337bb9">
              <div className="hero-grid inner">
                <div className="hero-w-width on-inner center">
                  <div className="blog-meta-wrapper">
                    <div className="category-text">{blog.date}</div>
                  </div>
                  <h1 className="display-1 for-blog-page">{blog.name}</h1>
                </div>
              </div>
              <div className="margin-60px">
                <div className={`blog-wrapper ${styles["blog-wrapper"]}`}>
                  <div className="relative-div">
                    <img
                      src={blog.image}
                      alt={blog.name}
                      className="photo-rounded"
                    />
                  </div>
                  <div className="margin-50px">
                    <div
                      className="w-richtext"
                      dangerouslySetInnerHTML={{ __html: blog.description }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`contact-form-right-side ${styles["contact-form-right-side"]}`}>
              <div
                className={`max-w split reverse mb-3 cust-max-w ${styles["cust-max-w"]}`}>
                <p className="subhead-main for-title">
                  Recent <span className="gray-text-color">Posts.</span>
                </p>
                <Link
                  to="/Blog"
                  className="relative inline-flex items-center justify-center p-2 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 rounded-full shadow-md group">
                  <span className="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-purple-500 group-hover:translate-x-0 ease">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </span>
                  <span className="absolute flex items-center justify-center w-full h-full text-purple-500 transition-all duration-300 transform group-hover:translate-x-full ease text-xs">
                    View All
                  </span>
                  <span className="relative invisible">View All</span>
                </Link>
              </div>
              <div>
                <div className="w-dyn-list">
                  <div
                    role="list"
                    className={`blog-list w-dyn-items ${styles["blog-list"]}`}>
                    {blogs.length > 0 ? (
                      blogs.map((blog, index) => (
                        <div
                          key={index}
                          role="listitem"
                          className={`w-dyn-item blog-card ${styles["blog-card"]}`}>
                          <div
                            data-w-id={`blog-item-${index}`}
                            className="blog-main w-clearfix">
                            <Link
                              style={{ backgroundImage: `url(${blog.image})` }}
                              to={`/BlogDetails/${blog.slug}`}
                              className={`blog-thumbnail ${styles["blog-thumbnail"]} w-inline-block`}>
                            </Link>
                            <div
                              className={`bottom-part ${styles["bottom-part"]}`}>
                              <div
                                className={`category-text ${styles["category-text"]}`}>
                                {blog.date}
                              </div>
                              <h3
                                className={`blog-title word-clamp ${styles["word-clamp"]}`}>
                                {blog.name}
                              </h3>
                              <div className="button-flex-category">
                                <Link
                                  to={`/BlogDetails/${blog.slug}`}
                                  className="button-underline w-inline-block">
                                  <div className="button-color">Read more</div>
                                  <div className="line-animation">
                                    <div className="underline"></div>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No blogs available at the moment.</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="max-w split reverse mb-3 mt-5">
                <p className="subhead-main for-title">Tags</p>
            </div>
            <div className={styles["d-flex"]}>
                {tags.length > 0 ? (
                    tags.map((tag) => {
                      let tagId = blog.tags_id;
                      let arr = [];
                      if(tagId != '' && tagId != null) {
                        arr = tagId.split(',');
                      }

                      if(arr.length > 0) {
                        if(arr.includes(tag.id)) {
                          return (
                            <div key={tag.id} className={styles["tags"]}>
                                <span className={styles["tags-hover"]}>
                                    {tag.name} 
                                </span>
                            </div>
                          )
                        }
                      } else {
                        return (
                          <p>No tags available at the moment.</p>
                        )
                      }
                    })
                ) : (
                    <p>No tags available at the moment.</p>
                )}
            </div>

              <div className="max-w split reverse mb-3 mt-5">
                <p className="subhead-main for-title">Share</p>
              </div>
              <div
                id="w-node-_1e35ac5f-8e4d-cf7f-73fa-3d7463ee8b74-63ee8b33"
                className={`foorer-list ${styles["foorer-list"]}`}>
                <div>
                  <div className="social-grid">
                    <a
                      onClick={() => shareOnFacebook(blog.name)}
                      className="social-link-main w-inline-block">
                      <img
                        src={Facebook}
                        alt="Share on Facebook"
                        className="social-icon"
                      />
                    </a>
                    <a
                      onClick={shareOnLinkedIn}
                      className="social-link-main w-inline-block">
                      <img
                        src={LinkedIn}
                        alt="Share on LinkedIn"
                        className="social-icon"
                      />
                    </a>
                    <a
                      onClick={shareOnInstagram}
                      className="social-link-main w-inline-block">
                      <img
                        src={Instagram}
                        alt="Share on Instagram"
                        className="social-icon"
                      />
                    </a>
                    <a
                      onClick={shareOnWhatsApp}
                      className="social-link-main w-inline-block">
                      <img
                        src={WhatsApp}
                        alt="Share on WhatsApp"
                        className="social-icon"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
